import { render, staticRenderFns } from "./FoodDetails.vue?vue&type=template&id=520ea2cc&scoped=true&"
import script from "./FoodDetails.vue?vue&type=script&lang=js&"
export * from "./FoodDetails.vue?vue&type=script&lang=js&"
import style0 from "./FoodDetails.vue?vue&type=style&index=0&id=520ea2cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ea2cc",
  null
  
)

export default component.exports